var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepsMovIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1366",
    "data-name": "Group 1366",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.94,
    height: 58.469,
    viewBox: "0 0 45.94 58.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081",
    "data-name": "Rectangle 1081",
    width: 45.94,
    height: 58.469,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    "data-name": "Group 1365",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25587",
    "data-name": "Path 25587",
    d: "M80.236,58.469H42.875a2.317,2.317,0,0,1-2.314-2.314V2.314A2.317,2.317,0,0,1,42.875,0H73.867L82.55,8.683V56.155a2.317,2.317,0,0,1-2.314,2.314",
    transform: "translate(-36.61)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25588",
    "data-name": "Path 25588",
    d: "M0,226.554l4.515,4.008.3-4.008Z",
    transform: "translate(0 -204.488)",
    fill: "#4283d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25589",
    "data-name": "Path 25589",
    d: "M80.236,58.469H42.875a2.317,2.317,0,0,1-2.314-2.314V2.314A2.317,2.317,0,0,1,42.875,0H73.867L82.55,8.683V56.155a2.317,2.317,0,0,1-2.314,2.314M42.875,1.129A1.186,1.186,0,0,0,41.69,2.314V56.155a1.186,1.186,0,0,0,1.185,1.185H80.236a1.186,1.186,0,0,0,1.185-1.185v-47L73.4,1.129Z",
    transform: "translate(-36.61)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25590",
    "data-name": "Path 25590",
    d: "M381.27,12.71a2.6,2.6,0,0,0,2.6,2.6h5.757L381.27,6.953Z",
    transform: "translate(-344.134 -6.276)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1080",
    "data-name": "Rectangle 1080",
    width: 32.959,
    height: 13.827,
    transform: "translate(0 8.24)",
    fill: "#6cb8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25591",
    "data-name": "Path 25591",
    d: "M80.28,125.415h1.451l.946,2.613c.117.343.225.721.342,1.081h.036c.117-.36.216-.739.333-1.081l.928-2.613h1.442v5.875H84.551v-2.154c0-.577.108-1.433.171-2h-.036l-.478,1.4-.838,2.244h-.73l-.838-2.244-.469-1.4H81.3c.063.568.171,1.424.171,2v2.154H80.28Z",
    transform: "translate(-72.461 -113.2)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25592",
    "data-name": "Path 25592",
    d: "M147.916,127.324c0-1.919,1.081-3.019,2.667-3.019s2.667,1.108,2.667,3.019-1.081,3.073-2.667,3.073-2.667-1.154-2.667-3.073m3.974,0c0-1.171-.5-1.874-1.307-1.874s-1.307.7-1.307,1.874.5,1.928,1.307,1.928,1.307-.748,1.307-1.928",
    transform: "translate(-133.509 -112.198)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25593",
    "data-name": "Path 25593",
    d: "M205.376,125.415h1.406l.7,2.739c.18.64.3,1.235.478,1.883H208c.171-.649.3-1.244.469-1.883l.694-2.739h1.352l-1.766,5.875h-1.6Z",
    transform: "translate(-185.372 -113.2)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25594",
    "data-name": "Path 25594",
    d: "M161.281,343.386H150.7a2.48,2.48,0,0,1-2.48-2.48v-9.43A2.48,2.48,0,0,1,150.7,329h10.579a2.48,2.48,0,0,1,2.48,2.48v9.43a2.48,2.48,0,0,1-2.48,2.48",
    transform: "translate(-133.785 -296.952)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25595",
    "data-name": "Path 25595",
    d: "M268.849,356.477l-3.535-2a1.3,1.3,0,0,1-.022-2.257l3.5-2.064,3.5-2.064a1.3,1.3,0,0,1,1.965,1.11l.039,4.06.039,4.06a1.3,1.3,0,0,1-1.944,1.147Z",
    transform: "translate(-238.874 -314.027)",
    fill: "#c9c9c9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsMovIcon);
export default __webpack_public_path__ + "static/media/steps-mov-icon.95ff74a54923c4d578d7ec391d81bf8d.svg";
export { ForwardRef as ReactComponent };